import { Button, ButtonProps } from '@pancakeswap/uikit'
import { message } from 'antd'
import { useWallet } from 'hooks/useWallet'
// @ts-ignore
// eslint-disable-next-line import/extensions
import { useActiveHandle } from 'hooks/useEagerConnect.bmp.ts'
import Trans from './Trans'

const ConnectWalletButton = ({ children, ...props }: ButtonProps) => {
  const handleActive = useActiveHandle()
  const { onPresentConnectModal } = useWallet()

  const handleClick = async () => {
    // if (typeof __NEZHA_BRIDGE__ !== 'undefined') {
    //   handleActive()
    // } else {
    //   onPresentConnectModal()
    // }
    try {
      onPresentConnectModal()
    } catch (error) {
      message.error(error.toString())
    }
  }

  return (
    <Button onClick={handleClick} {...props}>
      {children || <Trans>Connect Wallet</Trans>}
    </Button>
  )
}

export default ConnectWalletButton
